import { render, staticRenderFns } from "./HiboBadge.vue?vue&type=template&id=4bc174cb&"
import script from "./HiboBadge.vue?vue&type=script&lang=ts&"
export * from "./HiboBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports